import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Row, Col, Panel, Clearfix} from 'react-bootstrap';
import {FlircConfigFile} from "./utils";
import {map as _map} from 'lodash';

class FlircConfigPatterns extends Component {
    getPattern = (pattern, idx) => {
        let col = [
            <Col xs={12} sm={6} lg={4} key={idx.toString()}>
                <Panel header={<h1>Pattern {idx + 1}</h1>}>
                    <dl className="dl-horizontal">
                        <dt>Hash</dt>
                        <dd>0x{pattern.hash.toString(16).toUpperCase()}</dd>
                        <dt>Time elapsed</dt>
                        <dd>{pattern.timeElapsed} ms</dd>
                        <dt>Report ID</dt>
                        <dd>{pattern.reportId}</dd>
                        <dt>Modifier</dt>
                        <dd>0x{pattern.modifier.toString(16).toUpperCase()}</dd>
                        <dt>Key</dt>
                        <dd>0x{pattern.key.toString(16).toUpperCase()}</dd>
                        <dt>Description</dt>
                        <dd>{pattern.desc}</dd>
                    </dl>
                </Panel>
            </Col>
        ];
        let every3 = idx % 3 === 0;
        let every2 = idx % 2 === 0;
        if (idx !== 0 && (every2 || every3)) {
            col.unshift(<Clearfix key={idx.toString() + '_cf'} visibleSmBlock={every2} visibleMdBlock={every2} visibleLgBlock={every3} />)
        }
        return col;
    };

    render() {
        return (
            <Row>
                {_map(this.props.flircConfig.patterns, this.getPattern)}
            </Row>
        )
    }
}

FlircConfigPatterns.propTypes = {
    flircConfig: PropTypes.instanceOf(FlircConfigFile).isRequired,
};

export default FlircConfigPatterns;



// WEBPACK FOOTER //
// ./src/FlircConfigPatterns.js